
















import Vue from "vue";

export default Vue.component("SHHistoryCardSkeleton", {
  components: {
    QSkeleton: () => import("../elements/QSkeleton.vue"),
  },
});
